// extracted by mini-css-extract-plugin
export default {"wrap":"QE-z","fullWidth":"RE-z","hideOnDesktop":"SE-z","content":"TE-z","hasOpenedNav":"UE-z","crumbsList":"VE-z","dropdownsWrap":"WE-z"};